// extracted by mini-css-extract-plugin
export default {"container":"F0-z","heading":"G0-z","links":"H0-z","copy":"I0-z","subCopy":"J0-z","linksLeft":"K0-z","linksCenter":"L0-z","linksRight":"M0-z","link":"N0-z","onlyLink":"O0-z"};